declare global {
  interface Window {
    Pulse?: {
      open: () => void
      close: () => void
      toggle: () => void
      isOpen: () => boolean
      destroy: () => void
    }
  }
}

// @see https://github.com/Selectra-Dev/leo-myselectra/blob/develop/INTEGRATION.md
export const mountPulseWidget = (widgetUrl: string, spaceSlug: string, activationToken: string): void => {
  if (window.Pulse) {
    window.Pulse.open()
    return
  }

  const script = document.createElement('script')
  script.src = widgetUrl
  script.async = true
  script.dataset.space = spaceSlug
  script.dataset.activation = activationToken
  script.onload = () => window.Pulse?.open()
  document.body.appendChild(script)
}

export const destroyPulseWidget = (): void => {
  window.Pulse?.destroy()
}
